import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { QueryErrorResetBoundary } from '@tanstack/react-query';
import { Box } from '@givebutter/primitives/box';
import { Button } from '@givebutter/primitives/button';
import { show as showIntercomChat } from '@intercom/messenger-js-sdk';

interface WorkflowDetailsErrorBoundary extends PropsWithChildren {}
const WorkflowDetailsErrorBoundary = ({ children }: WorkflowDetailsErrorBoundary) => {
    return (
        <QueryErrorResetBoundary>
            {({ reset }) => (
                <ErrorBoundary
                    onReset={reset}
                    fallbackRender={({ resetErrorBoundary }) => (
                        <Box className="p-8">
                            <div className="flex min-h-40 flex-col items-center justify-center gap-4">
                                <p className="max-w-md text-center font-medium">
                                    There was an error while loading your workflow statistics. If
                                    the issues persists, please{' '}
                                    <Button
                                        variant="none"
                                        color="primary"
                                        onClick={() => showIntercomChat()}
                                        className="font-medium underline"
                                    >
                                        contact support
                                    </Button>
                                </p>
                                <Button
                                    variant="solid"
                                    size="sm"
                                    onClick={() => resetErrorBoundary()}
                                >
                                    <p>Try again</p>
                                </Button>
                            </div>
                        </Box>
                    )}
                >
                    {children}
                </ErrorBoundary>
            )}
        </QueryErrorResetBoundary>
    );
};

export { WorkflowDetailsErrorBoundary };
